/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Duplicate_BtnInputs */

const vi_order_duplicate_btn = /** @type {(inputs: Order_Duplicate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép đơn`)
};

/**

* @param {Order_Duplicate_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_duplicate_btn = /** @type {((inputs?: Order_Duplicate_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Duplicate_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_duplicate_btn(inputs)
});